import React, { useEffect, useState } from 'react'
import { checkEmail, checkName, checkPassword } from '../Login'
import styles from '../styles/Login.module.css'
import { useAuth } from '../hooks/useAuth'
import { useGoogleLogin } from '@react-oauth/google'
import { UserDTO } from '../Types/dto/user'

export default function Login({
	platform,
	completion,
	createTeamIfNotExist,
	resetToken,
	lang,
}: {
	completion: (userDTO?: UserDTO) => void
	platform: string
	createTeamIfNotExist: Boolean
	resetToken?: string
	lang?: string
}) {
	const auth = useAuth()
	const [isRegistration, setIsRegistration] = useState(true)
	const [isForgotPass, setIsForgotPass] = useState(false)
	const [email, setEmail] = useState<string>('')
	const [name, setName] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [passwordConfirmation, setPasswordConfirmation] = useState<string>('')
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		// Check if the router is ready (assuming it's ready when the pathname is not '/')
		if (window.location.pathname !== '/' || platform == 'wordpress') {
			setLoading(false)
		}
	}, [])

	const registerGoogle = useGoogleLogin({
		onSuccess: (tokenResponse) => {
			console.log(tokenResponse)
			auth.handleAuth(
				'auth/registerGoogle',
				{
					accessToken: tokenResponse.access_token,
				},
				completion,
				createTeamIfNotExist
			)
		},
	})

	useEffect(() => {
		window.fbAsyncInit = function () {
			window.FB.init({
				appId:
					process.env.NEXT_PUBLIC_ENV === 'prod'
						? '2773133082797983'
						: '402670860613108',
				cookie: true,
				xfbml: true,
				version: 'v15.0',
			})
			window.FB.AppEvents.logPageView()
		}
		;(function (d, s, id) {
			var js,
				fjs = d.getElementsByTagName(s)[0]
			if (d.getElementById(id)) {
				return
			}
			js = (d.createElement(s) as HTMLImageElement) || null
			js.id = id
			js.src = 'https://connect.facebook.net/en_US/sdk.js'
			fjs.parentNode?.insertBefore(js, fjs)
		})(document, 'script', 'facebook-jssdk')
	}, [])

	useEffect(() => {
		if (localStorage.getItem('isLoggedOut')) {
			setIsRegistration(false)
		}
	}, [])

	return loading ? (
		<></>
	) : (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '1rem',
				background: 'white',
				padding: '30px',
				borderRadius: '10px',
				alignSelf: 'center',
			}}
		>
			{platform == 'next' && !resetToken && (
				<>
					<button
						className={`${styles.button} ${styles.facebookBtn}`}
						onClick={() => {
							window.FB.login(
								(response: any) => {
									if (response.authResponse) {
										// User is authenticated and authorized
										const { accessToken } = response.authResponse
										auth.handleAuth(
											'auth/registerFacebook',
											{
												accessToken,
											},
											completion,
											createTeamIfNotExist
										)
									} else {
										// User cancelled the login process or didn't authorize your app
										console.log(
											'User cancelled login or did not fully authorize.'
										)
									}
								},
								{ scope: 'public_profile,email' } // Specify the requested permissions
							)
						}}
					>
						Facebook bejelentkezés
					</button>
					<button
						className={`${styles.button} ${styles.googleBtn}`}
						onClick={() => registerGoogle()}
					>
						Google bejelentkezés
					</button>
					<hr className="space-sm" />
				</>
			)}
			{!resetToken && (
				<input
					className={'input-text'}
					value={email}
					placeholder="E-mail"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setEmail(e.target.value)
					}
					autoComplete="email"
					style={{ margin: 0 }}
					name="email"
					type="text"
				/>
			)}
			{isRegistration && !resetToken && (
				<input
					className={'input-text'}
					value={name ?? ''}
					placeholder={lang == 'en' ? 'Name' : 'Név'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setName(e.target.value)
					}
					autoComplete="name"
					style={{ margin: 0 }}
					name="name"
					type="text"
				/>
			)}
			{!isForgotPass && (
				<input
					className={'input-text'}
					value={password ?? ''}
					type="password"
					placeholder={lang == 'en' ? 'Password' : 'Jelszó'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setPassword(e.target.value)
					}
					autoComplete={
						createTeamIfNotExist == true
							? 'off'
							: isRegistration
							? 'new-password'
							: 'current-password'
					}
					style={{ margin: 0 }}
					name="password"
				/>
			)}
			{(isRegistration || resetToken) && (
				<input
					className={'input-text'}
					value={passwordConfirmation ?? ''}
					type="password"
					placeholder={lang == 'en' ? 'Password again' : 'Jelszó újra'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
						setPasswordConfirmation(e.target.value)
					}
					autoComplete={
						createTeamIfNotExist == true
							? 'off'
							: isRegistration
							? 'new-password'
							: 'current-password'
					}
					style={{ margin: 0 }}
					name="passwordConfirm"
				/>
			)}
			{!isForgotPass && !resetToken && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						const element = document.activeElement as HTMLElement
						element.blur()
						if (!checkEmail(email) || !checkPassword(password)) {
							return
						}
						if (isRegistration) {
							if (email?.includes('freemail.hu')) {
								alert(
									'Amennyiben freemail-es e-maillel próbálsz bejelentkezni, abban az esetben kérjük használj másikat. A rendszer a freemail.hu-t nem támogatja.'
								)
								return
							}
							if (!checkName(name)) {
								return
							}
							auth.handleAuth(
								'auth/registerEmail',
								{
									name: name,
									email: email,
									password: password,
								},
								completion,
								createTeamIfNotExist
							)
						} else {
							auth.handleAuth(
								'auth/loginEmail',
								{
									email: email,
									password: password,
								},
								completion,
								false
							)
						}
					}}
					data-cy="login"
				>
					{isRegistration
						? lang == 'en'
							? 'Registration'
							: 'Regisztáció'
						: lang == 'en'
						? 'Login'
						: 'Bejelentkezés'}
				</button>
			)}
			{isForgotPass && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						const element = document.activeElement as HTMLElement
						element.blur()
						if (!checkEmail(email)) {
							return
						}
						auth.handleAuth(
							'sendResetPassword',
							{
								email: email,
							},
							completion,
							false
						)
					}}
				>
					Új jelszó
				</button>
			)}
			{resetToken && (
				<button
					className={`${styles.button} ${styles.registerBtn}`}
					onClick={() => {
						auth.handleAuth(
							'auth/resetPassword',
							{
								password,
								resetToken,
							},
							completion,
							false
						)
					}}
				>
					Módosítom
				</button>
			)}
			{!resetToken &&
				(lang == 'en' ? (
					<div>
						{!isRegistration ? (
							<div className={styles.div1}>
								No account yet?{' '}
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(true)
										setIsForgotPass(false)
									}}
								>
									Sign up for Tikex
								</a>
							</div>
						) : (
							<div className={styles.div1}>
								Have you registered yet?{' '}
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(false)
										setIsForgotPass(false)
									}}
								>
									Login
								</a>
							</div>
						)}
						{!isForgotPass && (
							<div className={styles.div1}>
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(false)
										setIsForgotPass(true)
									}}
								>
									Forgot your password?
								</a>
							</div>
						)}
					</div>
				) : (
					<div>
						{!isRegistration ? (
							<div className={styles.div1}>
								Nincs még fiókod?{' '}
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(true)
										setIsForgotPass(false)
									}}
								>
									Regisztrálj a Tikex-re
								</a>
							</div>
						) : (
							<div className={styles.div1}>
								Regisztráltál már?{' '}
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(false)
										setIsForgotPass(false)
									}}
								>
									Bejelentkezés
								</a>
							</div>
						)}
						{!isForgotPass && (
							<div className={styles.div1}>
								<a
									className={styles.link}
									onClick={() => {
										setIsRegistration(false)
										setIsForgotPass(true)
									}}
								>
									Elfelejtetted a jelszavad?
								</a>
							</div>
						)}
					</div>
				))}
		</div>
	)
}
